import styled from 'styled-components';

export const NoteText = styled.strong`
  margin-right: 0.5rem;
`;
